<template>
    <div class="banner">
        <avideo :srcs="['/assets/banners/games.webm','/assets/banners/games.mp4']" poster="/assets/banners/games.jpg"/>        
        <div class="inner">
            <div class="container">
                <div class="title" v-html="$t('banners.games.title')"></div>
                <router-link class="button button-lg" to="/#slots">{{$t('banners.games.button')}} <i class="icon-arrow_right_alt" /></router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BannerGames'
}
</script>

<style lang="scss" scoped>
    .title {
        font-size: 1rem;
        text-transform: uppercase;
        text-shadow: 1px 3px 0 $black, 1px 3px 5px $black;
    }

    .button {
        margin-top: $spacer;
    }
</style>
